import React from 'react';
import PropTypes from 'prop-types';
import { Button, P, Span } from 'components/Ui';
import { lockIcon } from 'images';
import styles from './styles.scss';

const ExclusionLockout = ({ onOpenPayBill }) => {
  const title = 'We’re sorry!';

  const text = (
    <div>
      <P>The site is not ready to accept orders for this location.</P>
    </div>
  );

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <img src={lockIcon} alt="lockIcon" className={styles.lock} />
        <Span className={styles.title}>{title}</Span>
        <span className={styles.text}>{text}</span>
        <Button
          className={styles.btn}
          text="Pay Bill"
          onClick={onOpenPayBill}
        />
      </div>
    </div>
  );
};

ExclusionLockout.propTypes = {
  onOpenPayBill: PropTypes.func.isRequired,
};

export default ExclusionLockout;
